/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据请求头中Authorization中的token信息获取C端用户会员信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: oauth2.CuUser;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/oauth2/token-user`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
